import _ from 'lodash';
import * as types from '../../constants/actionTypes';
import {firebase} from '../../firebase';
import ColorHelper from '../../businessLogic/colorHelper';

function requestProjects() {
  return {
    type: types.REQUEST_PROJECTS
  }
}

function receiveProjects(projects) {
  return {
    type: types.RECEIVE_PROJECTS,
    items: projects
  }
}

function receiveNewProject(newProject) {
  return {
    type: types.PROJECT_HAS_BEEN_CREATED,
    newItem: newProject
  }
}

function receiveUpdatedProject(updatedProject) {
  return {
    type: types.PROJECT_HAS_BEEN_UPDATED,
    updatedItem: updatedProject
  }
}

function receiveDeletedProject(deletedProject) {
  return {
    type: types.PROJECT_HAS_BEEN_DELETED,
    deletedItem: deletedProject
  }
}

export function fetchProjects() {
  return dispatch => {
    dispatch(requestProjects());
    firebase.database().ref('projects').once('value').then(function(snapshot) {
      let projects = _.toPairs(snapshot.val()).map((p) => {
        let project = p[1];
        project['key'] = p[0];
        return project;
      });
      dispatch(receiveProjects(_.sortBy(projects, ['code'])));
    });
  }
}

export function createProject(project) {
  return dispatch => {
    dispatch(requestProjects());

    firebase.database().ref('projects').once('child_added', function(data) {
      const newProject = data.val();
      newProject['key'] = data.key;
      dispatch(receiveNewProject(newProject));
    });

    project['color'] = ColorHelper.randomColor();
    firebase.database().ref('projects').push(project);
  }
}

export function updateProject(projectKey, newData) {
  return dispatch => {
    dispatch(requestProjects());

    const ref = firebase.database().ref("tasks");
    let taskKeys = [];
    let updates = {};
    ref.orderByChild("project").equalTo(projectKey).once('value', (tSnapshot) => {
      taskKeys = _.keys(tSnapshot.val());
      _.each(taskKeys, (tk) => {
        firebase.database().ref("user-tasks").orderByValue().once("value", function(uSnapshot) {
          uSnapshot.forEach(function(data) {
            firebase.database().ref(`user-tasks/${data.key}/tasks/${tk}`).once('value', (utSnapshot) => {
              if (utSnapshot.val() !== null) {
                let utUpdates = {};
                utUpdates[`user-tasks/${data.key}/tasks/${tk}/projectLabel`] = `${newData.code}-${newData.name}`;
                firebase.database().ref().update(utUpdates);
              }
            });
          });
        });
      });
      updates[`projects/${projectKey}/code`] = newData.code;
      updates[`projects/${projectKey}/name`] = newData.name;
      updates[`projects/${projectKey}/linkUrl`] = newData.linkUrl;
      return firebase.database().ref().update(updates).then(() => {
        dispatch(receiveUpdatedProject(newData));
      });
    });
  }
}

export function deleteProject(projectKey) {
  return dispatch => {
    dispatch(requestProjects());

    const ref = firebase.database().ref("tasks");
    let taskKeys = [];
    let updates = {};
    ref.orderByChild("project").equalTo(projectKey).once('value', (tSnapshot) => {
      taskKeys = _.keys(tSnapshot.val());
      _.each(taskKeys, (tk) => {
        firebase.database().ref("user-tasks").orderByValue().once("value", function(uSnapshot) {
          uSnapshot.forEach(function(data) {
            firebase.database().ref(`user-tasks/${data.key}/tasks/${tk}`).remove();
          });
        });
        updates[`tasks/${tk}`] = null;
      });
      updates[`projects/${projectKey}`] = null;
      return firebase.database().ref().update(updates).then(() => {
        dispatch(receiveDeletedProject({key: projectKey}));
      });
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/project/index.js
 **/